import { useState } from 'react'
import { reportPageOptions } from '../config/navigation'
import { Checkbox } from './ui/checkbox'
import { Label } from './ui/label'
import { Input } from './ui/input'
import { Button } from './ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'

export default function ReportPagePermissions({ permissions, onChange }) {
  const [search, setSearch] = useState('')
  const groups = reportPageOptions(permissions)
  const selected = permissions.reportPages
  const restricted = Array.isArray(selected)
  const options = groups.flatMap(group => group.items)
  const needle = search.trim().toLowerCase()
  const filtered = groups.map(group => ({ ...group, items: group.items.filter(item =>
    `${group.name} ${item.name}`.toLowerCase().includes(needle)) })).filter(group => group.items.length)

  return (
    <div className="space-y-3 rounded-md border border-border p-3">
      <Label htmlFor="report-page-mode">Report Viewer page access</Label>
      <Select value={restricted ? 'selected' : 'all'} onValueChange={value => onChange(value === 'all' ? null : [])}>
        <SelectTrigger id="report-page-mode"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All role pages</SelectItem>
          <SelectItem value="selected">Selected pages only</SelectItem>
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        {restricted ? 'Only checked pages appear in the sidebar and can be opened. Clinic access still applies.' : 'Includes all pages available to this role, including future additions.'}
      </p>
      {restricted && <>
        <Input aria-label="Search report pages" placeholder="Search pages…" value={search} onChange={event => setSearch(event.target.value)} />
        <div className="flex items-center justify-between text-xs">
          <span>{options.filter(item => selected.includes(item.href)).length} of {options.length} pages selected</span>
          <div className="flex gap-2">
            <Button type="button" variant="ghost" size="sm" onClick={() => onChange(options.map(item => item.href))}>Select all</Button>
            <Button type="button" variant="ghost" size="sm" onClick={() => onChange([])}>Clear</Button>
          </div>
        </div>
        <div className="max-h-64 overflow-y-auto space-y-4">
          {filtered.map(group => <fieldset key={group.name} className="space-y-2">
            <legend className="text-xs font-semibold text-muted-foreground mb-2">{group.name}</legend>
            {group.items.map(item => <div key={item.href} className="flex items-center gap-3">
              <Checkbox id={`report-page-${item.href}`} checked={selected.includes(item.href)} onCheckedChange={checked =>
                onChange(checked ? [...selected, item.href] : selected.filter(page => page !== item.href))} />
              <Label htmlFor={`report-page-${item.href}`} className="font-normal cursor-pointer">{item.name}</Label>
            </div>)}
          </fieldset>)}
          {!filtered.length && <p className="text-sm text-muted-foreground">No matching pages.</p>}
        </div>
        {!selected.length && <p className="text-xs text-muted-foreground">No pages selected. This user can sign in but cannot open any pages.</p>}
      </>}
    </div>
  )
}
